import { render, staticRenderFns } from "./ApprovReport.vue?vue&type=template&id=c5b58e2a&"
import script from "./ApprovReport.vue?vue&type=script&lang=js&"
export * from "./ApprovReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports